import { Component, OnInit,  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ChatComponent } from '../../_components/chat/chat.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    //public urlString:string = 'url';
    idCliente;
    urlContrato;
    urlString;
  constructor() { //this.router.routeReuseStrategy.shouldReuseRoute = function() {return false; };

}

  ngOnInit() {
    
  }

  dinero(evento)
  {
    console.log(evento);
    this.urlString = evento;

    console.log(this.urlString);

  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_pages/dashboard/dashboard.component.ts